import { createMergeReducer } from '../utils/reducer'
import { GetStaticPageContentResponse } from '@amzn/pv-starlight-presentation-service-lambda-typescript-client'

export type ExploreTabContent = GetStaticPageContentResponse | undefined

export const reducer = createMergeReducer(
  t => t.exploreTabContent,
  {} as ExploreTabContent
)
